// 404ErrorPage.js
import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Button } from "@mui/material";
import { Helmet } from "react-helmet-async";
import AnalyticsTracker from "../GASetup/AnalyticsTracker";
import { headingFonts, mainButtonStyles } from "../../Styles/Styles";

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh", // Full height of the viewport
        textAlign: "center", // Center text
      }}
    >
      <Helmet>
        <title>Not Found - Listed.ky</title>
        <meta name="description" content="Not Found - Listed.ky" />
      </Helmet>
      <AnalyticsTracker />
      <Typography
        variant="h1"
        sx={{ fontSize: "5rem", fontWeight: "bold", ...headingFonts }}
      >
        404
      </Typography>
      <Typography variant="h6" sx={{ mb: 3, ...headingFonts }}>
        Oops! The page you're looking for does not exist.
      </Typography>
      <Button
        onClick={() => navigate("/")}
        sx={{
          ...mainButtonStyles,
        }}
      >
        Go to Homepage
      </Button>
    </Box>
  );
};

export default NotFoundPage;
